import React, { Component } from "react";
import DownloadImg from '../../assets/images/download_icon.png'
export default class BtnCellRenderer extends Component {

  constructor(props) {
    super(props);
    this.onChangeValue = this.onClickValue.bind(this);
  }
  onClickValue(event) {
    this.props.onClick(this.props.data);
  }
  render() {
    return (
      <>
        <span onClick={this.onClickValue.bind(this)}><img src={DownloadImg} alt="Logo" style={{ width: "22px", cursor: "pointer", marginRight: "5px" }} /></span> {this.props.value}
      </>
    );
  }
}


